import { ENVIRONMENT, HttpParamsBuilder, Response } from '@agilox/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { UP_TO_DATE_VEHICLE_DATA } from '../constants/up-to-date-vehicle-data.const';
import { VehicleDataType } from '../enums/vehicle-data-type.enum';
import { VehicleDataActuality, VehicleTechnicalData } from '../interfaces';
import { toVehicleDataActuality } from '../utils/vehicle-data-actuality.util';

@Injectable({
	providedIn: 'root',
})
export class VehicleDataStatusService {
	private httpClient = inject(HttpClient);
	private environment = inject(ENVIRONMENT);

	getActuality(
		serials: string[],
		relevantDataTypes: VehicleDataType[],
		periodEnd?: number
	): Observable<VehicleDataActuality> {
		if (!relevantDataTypes.length) {
			return of(UP_TO_DATE_VEHICLE_DATA);
		}

		return this.getTechnicalData(serials).pipe(
			map((vehicles: VehicleTechnicalData[]) =>
				toVehicleDataActuality(vehicles, Date.now(), relevantDataTypes, periodEnd)
			),
			catchError(() => of(UP_TO_DATE_VEHICLE_DATA))
		);
	}

	getTechnicalData(serials: string[]): Observable<VehicleTechnicalData[]> {
		if (!serials?.length) {
			return of([]);
		}

		const params = HttpParamsBuilder.buildParameters(
			{ number: 0, size: serials.length },
			undefined,
			undefined,
			{ serial: serials.join(',') }
		);

		return this.httpClient
			.get<
				Response<VehicleTechnicalData>
			>(this.environment.server + '/v2/machineMgmt/technicalData', { params })
			.pipe(
				map((response: Response<VehicleTechnicalData>) =>
					Array.isArray(response?.data) ? response.data : []
				)
			);
	}
}
